import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakingLiveComponent } from './breaking-live.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    BreakingLiveComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    FormsModule
  ]
})
export class BreakingLiveModule { }
